export default "__VITE_ASSET__BuZMXWb___"